"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
function getProjectRotation(rotation) {
    const saved = rotation;
    let values = [];
    if (Array.isArray(rotation)) {
        values = rotation;
    }
    else if (saved && typeof saved === 'object') {
        values = [saved.x, saved.y, saved.z, saved.w];
    }
    if (values.length !== 4 ||
        !values.every((value) => typeof value === 'number' && Number.isFinite(value)) ||
        values.every((value) => value === 0)) {
        return new three_1.Quaternion();
    }
    return new three_1.Quaternion(values[0], values[1], values[2], values[3]);
}
exports.default = getProjectRotation;
